import { FC, ReactNode } from 'react';
import { InputProps, withField } from '../withField';

export interface CheckboxProps {
  suffix?: string | ReactNode;
  prefix?: string | ReactNode;
}

export const CheckboxInput: FC<InputProps<boolean> & CheckboxProps> = ({ onChange, value, id, suffix, prefix }) => {
  return (
    <div className="flex items-center gap-2">
      {prefix && <span className="break-all text-secondary-std mr-0.5 text-sm">{prefix}</span>}
      <input
        checked={value}
        onChange={e => {
          let newValue = e.target.checked;

          onChange(newValue);
        }}
        type="checkbox"
        id={id}
        className="p-2 bg-secondary-std text-primary-600 border-primary-std focus-within:ring-primary-600 relative flex items-center rounded-md shadow-sm focus-within:ring-2 dark:bg-white dark:bg-opacity-5 dark:ring-gray-700"
      />
      {suffix && <span className="break-all text-secondary-std ml-0.5 text-sm">{suffix}</span>}
    </div>
  );
};

export const CheckboxField = withField<boolean, CheckboxProps>(CheckboxInput);
